
import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { getCheckoutUrlWithUtms } from '@/lib/checkout';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-primary/90 backdrop-blur-md shadow-md py-3'
            : 'bg-transparent py-5'
        }`}
      >
        <div className="container mx-auto px-4 flex items-center justify-between">
          <div className="flex items-center">
            <a href="/" className="text-white font-bold text-2xl flex items-center">
              <img 
                src="/lovable-uploads/1de2e26f-4255-4f2e-8dc7-94f917c709eb.png" 
                alt="Método PPS Logo" 
                className="h-10 mr-3" 
              />
              Amamentação de Ouro
            </a>
          </div>

          {/* Desktop Menu */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => {
                const element = document.getElementById('method') || document.querySelector('[data-section="method"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-white hover:text-accent transition-colors font-medium"
            >
              Método
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('testimonials') || document.querySelector('[data-section="testimonials"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-white hover:text-accent transition-colors font-medium"
            >
              Depoimentos
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('course-content') || document.querySelector('[data-section="course-content"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="text-white hover:text-accent transition-colors font-medium"
            >
              Conteúdo
            </button>
            <Button
              className="btn-hover bg-accent hover:bg-accent-dark text-white font-medium rounded-full"
              onClick={() => window.location.href = getCheckoutUrlWithUtms('https://pay.hotmart.com/T84177472Y?off=s3ddbg8f&checkoutMode=10')}
            >
              Inscrever-se
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden absolute w-full bg-white shadow-lg transition-all duration-300 ease-in-out ${
            isMobileMenuOpen ? 'max-h-screen py-4' : 'max-h-0 overflow-hidden'
          }`}
        >
          <div className="container mx-auto px-4 flex flex-col space-y-4">
            <button
              className="text-gray-800 hover:text-accent-ink transition-colors py-2 font-medium text-left"
              onClick={() => {
                setIsMobileMenuOpen(false);
                const element = document.getElementById('method') || document.querySelector('[data-section="method"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Método
            </button>
            <button
              className="text-gray-800 hover:text-accent-ink transition-colors py-2 font-medium text-left"
              onClick={() => {
                setIsMobileMenuOpen(false);
                const element = document.getElementById('testimonials') || document.querySelector('[data-section="testimonials"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Depoimentos
            </button>
            <button
              className="text-gray-800 hover:text-accent-ink transition-colors py-2 font-medium text-left"
              onClick={() => {
                setIsMobileMenuOpen(false);
                const element = document.getElementById('course-content') || document.querySelector('[data-section="course-content"]');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Conteúdo
            </button>
            <Button
              className="btn-hover bg-accent hover:bg-accent-dark text-white font-medium w-full rounded-full"
              onClick={() => window.location.href = getCheckoutUrlWithUtms('https://pay.hotmart.com/T84177472Y?off=s3ddbg8f&checkoutMode=10')}
            >
              Inscrever-se
            </Button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navigation;
